const mapTabsMixin = {
  data: () => ({
    receptionLap: true,
    deliveryLap: false,
  }),
  beforeMount() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('deliveryLap') === '1') {
      this.receptionLap = false;
      this.deliveryLap = true;
    }
  },
  methods: {
    onChangeTab(tab) {
      this.receptionLap = tab === 'receptionLap';
      this.deliveryLap = tab === 'deliveryLap';
      this.changeQuery();
    },
    changeQuery() {
      const searchParams = new URLSearchParams(window.location.search);

      if (this.receptionLap) {
        searchParams.set('receptionLap', '1');
      } else {
        searchParams.delete('receptionLap');
      }

      if (this.deliveryLap) {
        searchParams.set('deliveryLap', '1');
      } else {
        searchParams.delete('deliveryLap');
      }

      window.history.replaceState(null, null, `?${searchParams.toString()}`);
    },
  },
};

export default mapTabsMixin;
